<script setup lang="ts">
import { computed, Ref, ref } from "vue";
import { useLandingStore } from "@/modules/landing-module";
import { IconChevronDownRegular } from "@packages/icon-library";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const activeElement: Ref<null | number> = ref(null);
const landingStore = useLandingStore();
const faq = computed(() => landingStore.faq);

const selectItem = (index: number) => {
  if (activeElement.value === index) {
    activeElement.value = null;
    return;
  }

  activeElement.value = index;
};
</script>

<template>
  <section class="landing-faq container">
    <h3>{{ t("home.faq.title") }}</h3>

    <div class="landing-faq__list">
      <button
        v-for="(item, index) in faq"
        :key="index"
        type="button"
        class="faq-item"
        :class="{ 'faq-item_active': index === activeElement }"
        @click="selectItem(index)"
      >
        <span>
          <span>{{ item.title }}</span>

          <IconChevronDownRegular />
        </span>

        <span v-html="item.body" />
      </button>
    </div>
  </section>
</template>

<style scoped lang="scss">
.landing-faq {
  > h3 {
    text-align: center;
    @include h3();
    color: var(--color-semantic-content-normal-primary);
  }

  > p {
    text-align: center;
    margin: calc($base-space * 4) 0 0;
    @include subtitle();
    color: var(--color-semantic-content-normal-secondary);
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr;
    gap: calc($base-space * 4);
    margin: calc($base-space * 16) 0 0;
  }
}
</style>
